
// import * as faceapi from 'face-api.js';
// import Camera from "../components/Camera";
import http from '@/components/services/http-common';
import IosCamera from "@/components/IosCamera";
import myBreadCrumb from "@/components/BreadCrumb"
import DatePicker from "@/components/DatePicker";
import Clock from "@/components/Clock.vue";
import moment from 'moment';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
// Initialize an agent at application startup.

export default {
  name: 'Enrollment',
  props:["breadcrumbs", "icon"],
  components: {
    // Camera,
    myBreadCrumb,
    "ios-camera": IosCamera,
    "date-picker": DatePicker,
    "clock": Clock,
  },
  computed: {
    WebAllowed() {
      let user = localStorage.getItem("user");
      user = JSON.parse(user);
      let employee = user.employeeCode;
      let value = localStorage.getItem("WebAllowed");
      return value.includes(employee);
    },
    progressPercentage() {
      return this.progress * (100/5);
    },
    srcGps() {
      return `https://www.google.com/maps/embed/v1/view?key=AIzaSyDaZ98rFDHwb-ZobVV36g-snAHe4GGSzcs&center=${this.form.lat},${this.form.long}&zoom=17`
    },
    btnEnroll () {
      let obj = {
        text : "",
        icon: "",
        color:"",
        func: (() => {})
      }
      if(this.formData.enroll == 'IN')
      {
        obj.text = "VÀO CA";
        obj.icon = "mdi-briefcase-clock-outline"
        obj.color = "light-blue darken-1";
      }else{
        obj.text = "RA CA";
        obj.icon = "mdi-briefcase-check-outline"
        obj.color = "light-green darken-1";
      }

      return obj;
    },
    
  },
  watch: {
    "form.date":{
      handler() {
        this.fetchInfo();
      }
    }
  },
  data(){
        return {
            ROOT_URL: "enrollments/",
            pageReady: false,
            confirmDialog: false,

            valid: true,
            overlay: true,
            is_mobile:true,
            ios_image: null,
            ios: true,
            loading: true,
            option: null,
            caltime: null,
            faceMatcher: null,
            name: "unknown",
            ready: "loading...",
            progress: 0,
            gps: {acc:"", long:""},
            ip4: undefined,
            ip6: undefined,

            //form
            form: {
              acc:"", long:"",
              ip4:undefined,
              ip6:undefined,
              time: "",
              date: moment().format("YYYY-MM-DD"),
              fingerprint: null,
            },

            formData: {
              date: new Date().toISOString().substr(0, 10),
              department: "",
              shift: "",
              shiftIn: "",
              shiftOut: "",
              breakIn: "",
              breakOut: "",
              checkIn: "",
              checkOut: "",
              enroll:"",
              allowEnroll: true,
            },
            statuses: [
              {text: "Tông thời gian", col:12, md: 4, value: 0, icon: "mdi-clock-check-outline", color: "light-green lighten-5", iconColor: "teal"},
              {text: "Thời gian đi trễ", col:6, md: 4, value: 0, icon: "mdi-clock-alert-outline", color: "amber lighten-5", iconColor: "orange accent-4"},
              {text: "Thời gian về sớm", col:6, md: 4, value: 0, icon: "mdi-clock-alert-outline", color: "red lighten-5", iconColor: "red accent-4"},
            ],
            note:{
              date:moment().format("YYYY-MM-DD"),
              note:"",
            },

            //clock
            time:"",
            totalTime: "",

            // data table
            headers: [
              {text: "Ngày chấm công", value: 'date'},
              {text: "Giờ vào ca", value: 'checkin'},
              {text: "Giờ ra ca", value: 'checkout'},
              {text: "Giờ công", value: 'total'},
              {text: "Vào trễ ", value: 'late'},
              {text: "Về sớm ", value: 'early'},
            ],
            items: [],
        }
  },
  methods: {
    sendExplain() {
      return http.post("enrollments/workday-note", 
        this.note
      )
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(location => {
          this.form.lat = location.coords.latitude;
          this.form.long = location.coords.longitude;
          this.form.acc = location.coords.accuracy;
        });
      } else { 
        console.log("Geolocation is not supported by this browser.");
      }
    },
    enrollConfirm () {
      if(this.pageReady){
        this.confirmDialog =true;
      }
    },
    enrollHandler() {
      this.$refs.form.validate();
      if(this.valid){
        if(this.formData.enroll == 'IN'){
          this.checkIn();
        }else {
          this.checkOut();
        }
        this.confirmDialog=false;
      }
    },
    checkInOut(date) {
      return http.get("enrollments/checkin", {
        params: {
          time: this.formData.checkIn,
          date: date,
          }
      }).then(res => {
        return http.get("enrollments/checkout", {
        params: {
          Now: this.formData.checkOut,
          Date: date,
          }
        })
      })
    },
    async generateData()
    {
      var date = moment("2021/12/01", "YYYY/MM/DD");
      for(var i = 0; i< 30; i++){
        let randI = Math.floor(Math.random() * 10);
        let randO = Math.floor(Math.random() * 10);
        let ci = moment(this.formData.shiftIn, "HH:mm a").add(randI, "minutes");
        let co = moment(this.formData.shiftOut, "HH:mm a").add(randO, "minutes");
        let ciTime = ci.format("HH:mm");
        let coTime = co.format("HH:mm");
        
        let ciForm= {
          time: ciTime,
          date: date.format("YYYY-MM-DD"),
        };
        let coForm= {
          time: coTime,
          date: date.format("YYYY-MM-DD"),
        };
        let ciPromise = await http.post("enrollments/checkin", ciForm);
        let coPromise = await http.post("enrollments/checkout", coForm);
        date.add(1, "days");
      }
    },
    captureImage (input) {
      this.ios_image = input;
    },
    showTime () {
      var date = new Date();
      var h = date.getHours(); // 0 - 23
      var m = date.getMinutes(); // 0 - 59
      var s = date.getSeconds(); // 0 - 59
      
      h = (h < 10) ? "0" + h : h;
      m = (m < 10) ? "0" + m : m;
      s = (s < 10) ? "0" + s : s;
    },
    checkIn() {
      return http.post("enrollments/checkin", this.form).then(res => {
        this.$Swal.fire({
            icon: 'success',
            title: 'Vào ca làm việc',
            text: 'Chúc bạn một ngày làm việc vui vẻ',
        });
        this.fetchInfo();
      }).catch(err => {
        console.log(err)
      });
    },
    
    checkOut () {
      return http.post("enrollments/checkout", this.form).then(res => {
        console.log(res.data)
        this.$Swal.fire({
            icon: 'success',
            title: 'Ra ca làm việc',
        })
        this.fetchInfo();
        this.totalTime = res.data.workTime;
      }).catch(err => {
      });
    },
    testReset (){
      return http.get(this.ROOT_URL + "test-reset", {
        params: {date: this.formData.date}
      }).then(res => {console.log(this.fetchInfo())})
    },
    fetchInfo () {
      this.pageReady = false;
      return http.get(this.ROOT_URL + "info", {
        params: {date: this.form.date}
      }).then(res => {
        console.log(res.data);
        var data = res.data;
        this.loading = false;
        this.formData.enroll = data.enroll;
        this.formData.shiftIn = data.startShift;
        this.formData.Breakin = data.startBreak;
        this.formData.breakOut = data.endBreak;
        this.formData.shiftOut = data.endShift;
        this.items = data.enrolls;
        if(data.timesheet)
        {
          this.statuses[0].value = data.timesheet.actualTime;
          this.statuses[1].value = data.timesheet.late;
          this.statuses[2].value = data.timesheet.early;
        }
      })
      .catch(err => {}).finally(() => {
        this.pageReady = true;
      })
    },

    mobileCheck(){
      let vm = this;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) vm.is_mobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
    },

    fetchData () {
      http.get("enrollments/fetch-data")
      .then(res => {
        console.log(res);
      })
    },
    allProgress(proms, progress_cb) {
      let d = 0;
      progress_cb(0);
      for (const p of proms) {
        p.then(()=> {    
          d ++;
          progress_cb( (d * 100) / proms.length );
        });
      }
      return Promise.all(proms);
    },
  },
  async created() {
    const internalIp = require('internal-ip');
    (async () => {
      this.form.ip4 = await internalIp.v4();
      this.form.ip6 = await internalIp.v6();
    })();
    this.mobileCheck();
    this.getLocation();

    this.fetchInfo();
    this.interval = setInterval(() => this.showTime(), 1000);
    
    const fpPromise = FingerprintJS.load();
    await (async () => {
      // Get the visitor identifier when you need it.
      const fp = await fpPromise
      const result = await fp.get()

      // This is the visitor identifier:
      this.form.fingerprint = result.visitorId
    })()
    
  },
  async destroyed() {
    this.interval = clearInterval();
  },
}